import { render, staticRenderFns } from "./LayoutWithoutMenu.vue?vue&type=template&id=c5f836f8&scoped=true"
import script from "./LayoutWithoutMenu.vue?vue&type=script&lang=js"
export * from "./LayoutWithoutMenu.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithoutMenu.vue?vue&type=style&index=0&id=c5f836f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f836f8",
  null
  
)

export default component.exports